export default __webpack_public_path__ + "static/media/parallax2.d8d5b31d.jpg";